/* eslint-disable no-restricted-imports */
import React from 'react'
import {UIGameActionButton} from '../../../common/UIGameActionButton'
import {T} from '../../../common/T'
import {getHelperText} from '../utils'
import IconSpecialBuildPhaseFlag from '@static/images/icon_special_build_phase_flag.svg'
import {useGameStore} from '../../../store/GameStoreContext'
import {TurnState} from '@colonist/game-states'
import {useUIGameSocketContext} from '../../../contexts/UIGameSocketContext'

export const UIGameActionButtonSpecialBuildPhase = ({
    className,
    hideTooltip,
}: {
    className?: string
    hideTooltip?: boolean
}) => {
    const myColor = useGameStore((state) => state.myColor)
    const isPaused = useGameStore((state) => state.gamePause.isPaused)
    const {sendRequestSpecialBuildPhase, sendCancelSpecialBuildPhase} = useUIGameSocketContext()
    const isRequestingSpecialBuildPhase = useGameStore((state) =>
        state.gameState.mechanicSpecialBuildPhaseState?.playerStates?.[myColor]?.isRequesting || false)
    const currentState = useGameStore((state) => state.gameState.currentState)
    const isInitialPlacement = currentState.turnState === TurnState.InitialPlacement
    const disabled = isPaused || isInitialPlacement

    const onClick = () => {
        if(disabled) return
        if(isRequestingSpecialBuildPhase) {
            sendCancelSpecialBuildPhase()
        } else {
            sendRequestSpecialBuildPhase()
        }
    }

    const helperText = getHelperText({
        isInitialPlacement: isInitialPlacement,
    })

    return <UIGameActionButton
        className={className}
        highlight={isRequestingSpecialBuildPhase}
        disabled={disabled}
        helperText={helperText}
        iconPath={IconSpecialBuildPhaseFlag}
        centerTextTooltip
        tooltipTitle={hideTooltip ? undefined : <T id='strings:game.tooltips.requestSpecialBuildPhase'/>}
        onClick={onClick}
    />
}
